module.exports = __webpack_public_path__ + "static/media/mobile.293a3dc5.png";